const cards = [
  {
    label: '热播剧集',
    title: '暗夜追踪 第二季',
    desc: '悬疑犯罪题材高分回归，剧情紧凑全程高能，豆瓣评分9.1。每周三、六更新，目前已更新至第12集。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20TV%20series%20poster%20with%20noir%20aesthetic%2C%20city%20nightscape%20background%2C%20detective%20silhouette%2C%20warm%20orange%20and%20teal%20color%20grade%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20premium%20entertainment%20visual&width=800&height=500&seq=card-show-01&orientation=landscape',
  },
  {
    label: '新剧推荐',
    title: '星际迷航：新纪元',
    desc: '史诗级科幻巨制，讲述人类探索未知星系的故事。视效震撼，剧情宏大，全集一次性上线，一次看过瘾。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20opera%20poster%20with%20futuristic%20spaceship%20and%20distant%20galaxy%2C%20nebulae%20and%20stars%2C%20warm%20gold%20and%20deep%20space%20blue%20contrast%2C%20cinematic%20movie%20poster%20style%2C%20heroic%20composition&width=800&height=500&seq=card-show-02&orientation=landscape',
  },
  {
    label: '高分经典',
    title: '长安秘史',
    desc: '大唐盛世背景下的宫廷权谋大戏，服化道精良，演技在线。高清修复版画质升级，重温经典不容错过。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20historical%20drama%20poster%2C%20Tang%20dynasty%20aesthetic%2C%20traditional%20hanfu%20costumes%2C%20warm%20golden%20and%20red%20palace%20interior%2C%20elegant%20composition%2C%20cinematic%20lighting%20with%20lanterns&width=800&height=500&seq=card-show-03&orientation=landscape',
  },
  {
    label: '韩剧热播',
    title: '深海冒险',
    desc: '浪漫与冒险交织的奇幻爱情剧，取景唯美，OST动听。韩国同步播出，中文字幕第一时间更新。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20poster%20with%20coastal%20scenery%2C%20ocean%20sunset%20background%2C%20couple%20silhouette%2C%20soft%20warm%20lighting%2C%20dreamy%20aesthetic%2C%20emotional%20cinematic%20composition&width=800&height=500&seq=card-show-04&orientation=landscape',
  },
  {
    label: '动漫佳作',
    title: '异世界勇者',
    desc: '年度最受期待异世界题材动画，制作精良画面炸裂。字幕组精心翻译，每集提供中日双语字幕。',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20poster%20with%20adventurer%20character%20in%20magical%20forest%2C%20vibrant%20warm%20colors%2C%20detailed%20illustration%20style%2C%20dynamic%20action%20pose%2C%20golden%20magical%20particles%2C%20epic%20cinematic%20composition&width=800&height=500&seq=card-show-05&orientation=landscape',
  },
  {
    label: '综艺娱乐',
    title: '极限挑战 第十季',
    desc: '国民级户外真人秀重磅回归，全新嘉宾阵容带来更多笑料与感动。每周日晚更新，欢乐不间断。',
    img: 'https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20poster%20with%20group%20of%20entertainers%20in%20colorful%20city%20setting%2C%20fun%20and%20energetic%20atmosphere%2C%20bright%20warm%20sunlight%2C%20playful%20composition%2C%20reality%20TV%20aesthetic&width=800&height=500&seq=card-show-06&orientation=landscape',
  },
  {
    label: '纪录片精选',
    title: '地球脉动：亚洲篇',
    desc: 'BBC级别自然纪录片，4K超高清拍摄亚洲珍稀动植物。每一帧都是壁纸，带你领略大自然的壮美。',
    img: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20Asian%20landscapes%2C%20mountains%20and%20bamboo%20forests%2C%20wildlife%20in%20natural%20habitat%2C%20warm%20golden%20hour%20lighting%2C%20breathtaking%20vista%2C%20National%20Geographic%20style%20photography&width=800&height=500&seq=card-show-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section
      id="cards"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100 scroll-mt-16"
    >
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center">
          精选推荐
        </h2>
        <div className="mt-2 w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card) => (
            <article
              key={card.title}
              className="group rounded-lg overflow-hidden bg-background-50 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium bg-background-50/90 text-foreground-800 rounded-full whitespace-nowrap">
                  {card.label}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}